const MAX_PARAMETER_LENGTH = 100;
const PROMOTION_COOKIE = "ww_ga4_promotion";

const cleanString = (value) => String(value ?? "")
  .trim()
  .slice(0, MAX_PARAMETER_LENGTH);

const buildPromotionItem = (offer, { index = 0, slot = "athlete_board_promotions" } = {}) => ({
  item_id: `promotion:${cleanString(offer?.key)}`,
  item_name: cleanString(offer?.promotionName || offer?.title),
  item_category: "promotion",
  promotion_id: cleanString(offer?.key),
  promotion_name: cleanString(offer?.promotionName || offer?.title),
  creative_name: cleanString(offer?.creativeName || "board_promo_card"),
  creative_slot: cleanString(`${slot}_${index + 1}`),
  index,
  quantity: 1,
});

const pushPromotionEvent = (eventName, offer, options = {}) => {
  if (typeof window === "undefined" || !eventName || !offer?.key) {
    return false;
  }

  const item = buildPromotionItem(offer, options);
  if (eventName === "select_promotion" && offer.key === "deposit-match" && typeof document !== "undefined") {
    const attribution = {
      promotion_id: item.promotion_id,
      promotion_name: item.promotion_name,
      creative_name: item.creative_name,
      creative_slot: item.creative_slot,
    };
    document.cookie = `${PROMOTION_COOKIE}=${encodeURIComponent(JSON.stringify(attribution))}; Max-Age=1800; Path=/; SameSite=Lax`;
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: eventName,
    ecommerce: {
      creative_name: item.creative_name,
      creative_slot: item.creative_slot,
      promotion_id: item.promotion_id,
      promotion_name: item.promotion_name,
      items: [item],
    },
  });
  return true;
};

const trackPromotionViewed = (offer, options = {}) => (
  pushPromotionEvent("view_promotion", offer, options)
);

const trackPromotionSelected = (offer, options = {}) => (
  pushPromotionEvent("select_promotion", offer, options)
);

export {
  buildPromotionItem,
  pushPromotionEvent,
  trackPromotionSelected,
  trackPromotionViewed,
};
